<!-- Title -->
<div style="text-align: center; margin-bottom: 20px;">
  <h2 style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f; margin: 0;">Elige beneficiario</h2>
</div>

<!-- Search + Add button -->
<div style="display: flex; gap: 12px; margin-bottom: 16px; flex-wrap: wrap;">
  <div style="flex: 1; min-width: 200px;">
    <input type="text" (keyup)="buscar($event)" [(ngModel)]="searchTxt" placeholder="Buscar beneficiario..."
      style="width: 100%; padding: 12px 16px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 0.9rem; color: #1e5a3f; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
      onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
  </div>
  <button type="button" (click)="openCreateDialog()"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 16px; background: white; color: #1C593D; border: 2px dashed #34d399; border-radius: 12px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
    onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">add</mat-icon>
    Agregar
  </button>
</div>

<!-- Beneficiary list -->
<div *ngIf="listaBeneficiariosFiltrados && listaBeneficiariosFiltrados.length > 0"
  style="display: flex; flex-direction: column; gap: 10px; margin-bottom: 20px; max-height: 360px; overflow-y: auto;">
  <div *ngFor="let beneficiario of listaBeneficiariosFiltrados" (click)="elegir(beneficiario)"
    style="padding: 14px 16px; border-radius: 12px; cursor: pointer; transition: all 0.2s ease;"
    [style.background]="beneficiarioEscogido === beneficiario ? '#f0fdf4' : 'white'"
    [style.border]="beneficiarioEscogido === beneficiario ? '2px solid #34d399' : '1px solid #e5e7eb'">
    <div style="display: flex; align-items: center; gap: 10px;">
      <!-- Radio visual -->
      <div style="width: 20px; height: 20px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center;"
        [style.border]="beneficiarioEscogido === beneficiario ? '2px solid #1C593D' : '2px solid #d1d5db'">
        <div *ngIf="beneficiarioEscogido === beneficiario"
          style="width: 10px; height: 10px; border-radius: 50%; background: #1C593D;"></div>
      </div>
      <div style="flex: 1; min-width: 0;">
        <p style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f; margin: 0 0 4px;">{{ beneficiario.nombre }}</p>
        <p style="font-size: 0.78rem; color: #6b7280; margin: 0;">{{ beneficiario.banco.nombre }}</p>
        <p *ngIf="beneficiario.banco.codigoBanco === 'BOFA'" style="font-size: 0.78rem; color: #6b7280; margin: 2px 0 0;">Cuenta: {{ beneficiario.numeroCuenta }}</p>
        <p style="font-size: 0.78rem; color: #6b7280; margin: 2px 0 0;">{{ beneficiario.identificador }}</p>
      </div>
    </div>
  </div>
</div>

<!-- Continuar button -->
<button type="button" (click)="emitChangeStep()"
  [disabled]="beneficiarioEscogido == undefined"
  [style.opacity]="beneficiarioEscogido == undefined ? '0.5' : '1'"
  [style.cursor]="beneficiarioEscogido == undefined ? 'not-allowed' : 'pointer'"
  style="width: 100%; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
  onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
  Continuar
</button>
